// TODO convert all class models to interface
export class ActivitiesSearchForm {
  public caseReference = "";
  public fileReference = "";
  public additionalReference = "";
  public from = "";
  public to = "";
}
